import { Link } from "react-router-dom";
import { Wordmark } from "./Logo";
import { useLang } from "../../lib/i18n";

export const Footer = ({ contact, logo }) => {
  const { t, pick } = useLang();
  return (
    <footer className="relative mx-auto flex max-w-[1440px] flex-col gap-4 border-t border-white/[0.07] px-5 py-8 pb-28 sm:flex-row sm:items-center sm:justify-between sm:pe-60 lg:px-10 lg:pe-60 lg:pb-8" data-testid="site-footer">
      <Wordmark src={logo} />
      <p className="text-sm text-zinc-400">© {new Date().getFullYear()} MRVA Productions · {pick(contact, "location")}</p>
      <Link to="/admin" className="text-sm text-zinc-400 underline-offset-4 hover:text-white hover:underline" data-testid="footer-admin-link">{t.staffLogin}</Link>
    </footer>
  );
};
